export default "__VITE_ASSET__KYISBrln__"